export default "__VITE_ASSET__f73be630__"